import React from 'react';
import styled from 'styled-components';
import EllipsesControl from '../EllipsesControl/EllipsesControl';

export default function NameColumn(params) {
	const isClassLevel = params.node.level === 2;
	return (
		<StyledNameColumn className="StyledNameColumn">
			{params.value && (
				<>
					<EllipsesControl
						noOfLines={1}
						content={params.value}
						tooltip={params.value}
						tooltipClass="tooltipCustomWidth"
					/>
				</>
			)}
		</StyledNameColumn>
	);
}

const StyledNameColumn = styled.section`
	font-size: var(--px-14);
	font-weight: 300;
	line-height: var(--px-24);
	width: 93%;
`;
